import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '1',
    title: 'Recetario Express de Viandas Calientes',
    price: 'USD 17',
    color: '#DC2626'
  }, {
    num: '2',
    title: 'Plantillas de Menús Semanales "Copiar y Usar"',
    price: 'USD 17',
    color: '#EA580C'
  }, {
    num: '3',
    title: 'Lista Maestra Anti-Olvido para Viandas',
    price: 'USD 17',
    color: '#16A34A'
  }, {
    num: '4',
    title: 'Combo de Snacks Inteligentes para Completar Viandas',
    price: 'USD 17',
    color: '#2563EB'
  }, {
    num: '5',
    title: 'Guía de Combinaciones Rápidas para Días de Caos',
    price: 'USD 17',
    color: '#7C3AED'
  }];
  return <section className="relative bg-cosmic-deep pt-2 pb-1 md:pt-4 md:pb-2 px-4 overflow-hidden" data-id="element-34" data-mp="19mdufr5vu65q">
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange/15 rounded-full blur-3xl pointer-events-none" data-id="element-35" data-mp="1nhzhhssk2fvi"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-600/15 rounded-full blur-3xl pointer-events-none" data-id="element-36" data-mp="3pqbqf3x4yixf"></div>

      <div className="relative max-w-6xl mx-auto" data-id="element-37" data-mp="3trdsdsift933">
        <div className="text-center mb-6" data-id="element-38" data-mp="3ts6ziulb60lr">
          <div className="block w-full bg-gradient-to-r from-gold via-gold-2 to-gold border-2 border-gold rounded-full px-3 md:px-8 py-3 md:py-4 shadow-[0_0_40px_rgba(245,166,35,0.55)] mb-3" data-id="element-39" data-mp="2l2vm8kgmuhk">
            <h2 className="font-display font-black text-[#1a0533] text-base md:text-4xl tracking-tight whitespace-nowrap" data-id="element-40" data-mp="ck1z7cqdbzxp">
              🎁 MÁS 5 BONOS ESTRATÉGICOS
            </h2>
          </div>
          <p className="text-gold font-bold text-sm md:text-lg uppercase tracking-wide" data-id="element-41" data-mp="lcdnot1x9db1">
            GRATIS CON TU MEGAPACK
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 mb-3 md:mb-4 max-w-3xl lg:max-w-6xl mx-auto" data-id="element-42" data-mp="qaoron5jctlc">
          {bonuses.map(b => <div key={b.num} className={`bg-[#1C1040] rounded-xl overflow-hidden border border-white/10 flex items-stretch ${b.num === '5' ? 'md:col-span-2 md:w-[calc(50%-0.5rem)] md:justify-self-center lg:col-span-1 lg:w-auto' : ''}`} data-id="element-43" data-mp="108ux3eqjwhuy">
              <div className="w-1.5 shrink-0" style={{
            backgroundColor: b.color
          }} data-id="element-44" data-mp="kb1ze1ouegjm"></div>
              <div className="flex items-center gap-2 px-2.5 py-1.5 flex-grow" data-id="element-45" data-mp="fj0qmpqvv7yc">
                <div className="text-lg shrink-0 leading-none" data-id="element-46" data-mp="tafd56k01ra5">🎁</div>
                <div className="flex flex-col justify-center min-w-0 flex-grow" data-id="element-47" data-mp="odf2sjg4a2d8">
                  <div className="text-[9px] font-bold tracking-widest uppercase leading-none mb-0.5" style={{
                color: b.color
              }} data-id="element-48" data-mp="139mknd41yrpc">
                    Bono {b.num}
                  </div>
                  <h3 className="font-display font-bold text-white text-[12px] md:text-[13px] leading-[1.1]" data-id="element-49" data-mp="3026c29qqh8l8">
                    {b.title}
                  </h3>
                  <div className="flex items-center gap-1.5 mt-0.5 leading-none" data-id="element-50" data-mp="1fknlrk7gb264">
                    <span className="text-white/40 line-through font-medium text-[9px] md:text-[10px]" data-id="element-51" data-mp="1khxb6zuubdty">
                      {b.price}
                    </span>
                    <span className="bg-check/15 text-check px-1.5 py-0.5 rounded-full text-[9px] font-bold tracking-wide" data-id="element-52" data-mp="1at5ob64mzjpw">
                      ✅ GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center max-w-xl mx-auto bg-gold/10 border border-gold/30 rounded-2xl p-4 md:p-5" data-id="element-53" data-mp="mvgh03helgcf">
          <p className="text-white/85 text-xs md:text-base mb-2 whitespace-nowrap" data-id="element-54" data-mp="rubb41ktmrbu">
            Valor total de los 5 bonos:{' '}
            <span className="line-through text-white/50" data-id="element-55" data-mp="2haiybdwats49">USD 85</span> →{' '}
            <span className="text-gold font-bold" data-id="element-56" data-mp="2m9419l2xqpwe">GRATIS</span>
          </p>
          <p className="font-display font-bold text-gold text-xl md:text-2xl leading-tight" data-id="element-57" data-mp="m6ckw7zmisrt">
            🎁 GRATIS
          </p>
          <p className="font-display font-bold text-gold text-xs md:text-sm uppercase tracking-widest mt-1 mb-2" data-id="element-58" data-mp="h702bzfsc7v1">
            Solo en este lanzamiento
          </p>
          <p className="text-white/70 text-xs md:text-sm" data-id="element-59" data-mp="86jzms6v94r8">
            Incluidos en tu MegaPack. Siempre.
          </p>
        </div>
      </div>
    </section>;
}